import React from 'react';
import { Navigate } from 'react-router-dom';
import { useModules } from '../hooks/useModules';
import ModuleNotAvailable from './ModuleNotAvailable';

/**
 * Composant pour protéger les routes selon les modules activés
 */
function ProtectedRoute({ children, requiredModule, moduleName }) {
  const { isModuleEnabled, loading } = useModules();

  // Afficher un loader pendant le chargement
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Si pas de module requis, afficher le contenu
  if (!requiredModule) {
    return children;
  }

  // Si le module est activé, afficher le contenu
  if (isModuleEnabled(requiredModule)) {
    return children;
  }

  // Sinon, afficher le message "Module non disponible"
  return <ModuleNotAvailable moduleName={moduleName || requiredModule} />;
}

export default ProtectedRoute;
